import React, { useEffect } from "react";
import "./styles.scss";
import { withRouter } from "react-router-dom";
import { Button } from "../../../components";

const Index = (props) => {
  return (
    <>
      <div className="image-generate-wrapper">
        <div className="igw__header">
          <div className="igw__h-title">
            Turn Your Ideas into Stunning Ads with AI
          </div>
          <div className="igw__h-subTitle">
            AI-powered ad creatives in seconds. No design skills needed
          </div>
        </div>
        <div className="igw__subscription-banner">
          <div className="d-flex flex-row mb-2">
            <div>
              <div className="igw__sb-title">Unlock Unlimited Ads </div>
              <div className="igw__sb-subTitle">
                Upgrade to Premium – Just LKR 1600/month
              </div>
            </div>
            <div className="igw__sb-more">See more</div>
          </div>
          <div className="d-flex flex-row">
            <Button
              data={{
                btnName: "Start 7-Day Free Trial",
                buttonType: "secondary s-border x",
                buttonSize: "md-x",
                // isLoading: isLoading,
              }}
              onClick={async (e) => {}}
            />
            <Button
              data={{
                btnName: "Subscribe Premium now",
                buttonType: "primary",
                buttonSize: "md-x ml-2",
                // isLoading: isLoading,
              }}
              onClick={async (e) => {}}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default withRouter(Index);
